/* eslint-disable */
/* Motor de cálculo: no toca el DOM. Recibe filas de cada fuente y arma los modelos de tabla.
   Para pasar a datos reales alcanza con que cada fuente devuelva las mismas columnas. */
(function (root) {
  const GOOGLE_TYPES = ['Search', 'PMax', 'Demand Gen', 'Shopping'];
  const META_TYPES = ['Advantage AO', 'Advantage+', 'Manual'];
  const LY_OFFSET_DIAS = 364; // mismo día de la semana del año anterior
  const NO_PAGO = ['orgánico', 'organico', 'directo', 'organic', 'direct'];

  const dayIdx = (s) => Math.round(Date.UTC(+s.slice(0, 4), +s.slice(5, 7) - 1, +s.slice(8, 10)) / 86400000);
  const dayStr = (n) => new Date(n * 86400000).toISOString().slice(0, 10);
  const num = (x) => { const v = +x; return Number.isFinite(v) ? v : 0; };

  /* Regla de atribución Shopify (último clic): orgánico y directo no son pago;
     todo lo demás es pago, y si viene sin nombre de campaña va a Advantage+. */
  function clasificar(canal, tipo) {
    const c = String(canal || '').trim();
    const t = String(tipo || '').trim();
    if (NO_PAGO.includes(c.toLowerCase())) return null;
    if (!t) return ['Meta', 'Advantage+'];
    if (GOOGLE_TYPES.includes(t)) return ['Google', t];
    if (META_TYPES.includes(t)) return ['Meta', t];
    return [c === 'Google' ? 'Google' : 'Meta', t];
  }

  function prep(src) {
    const ads = src.ads.map((r) => { const d = dayIdx(r.fecha); return { d, t: d * 24 + num(r.hora), m: r.marca, p: r.plataforma, c: r.tipo_campana, inv: num(r.inversion_usd) }; });
    const shop = src.shopify.map((r) => {
      const d = dayIdx(r.fecha); const k = clasificar(r.canal, r.tipo_campana);
      return { d, t: d * 24 + num(r.hora), m: r.marca, paid: !!k, p: k ? k[0] : null, c: k ? k[1] : null, ses: num(r.sesiones), tk: num(r.tickets), rev: num(r.ingresos_uyu) };
    });
    const ga = (src.ga4 || []).map((r) => { const d = dayIdx(r.fecha); return { d, t: d * 24 + num(r.hora), m: r.marca, ses: num(r.sesiones), tk: num(r.transacciones), rev: num(r.ingresos_uyu) }; });
    const obj = (src.objetivos || []).map((r) => ({ d: dayIdx(r.fecha), m: r.marca, inv: num(r.obj_inversion_usd), venta: num(r.obj_venta_uyu), ses: num(r.obj_sesiones), tk: num(r.obj_tickets) }));
    const periodos = (src.periodos || []).map((r) => ({ p: r.periodo, a: dayIdx(r.desde), b: dayIdx(r.hasta), la: dayIdx(r.desde_ly), lb: dayIdx(r.hasta_ly) }));
    const roi = new Map((src.objetivos_roi || []).map((r) => [r.periodo + '|' + r.marca, num(r.roi_objetivo)]));
    const brands = [];
    for (const r of ads) if (!brands.includes(r.m)) brands.push(r.m);
    for (const r of shop) if (!brands.includes(r.m)) brands.push(r.m);
    return { ads, shop, ga, obj, periodos, roi, brands };
  }

  const win = (desde, hasta, corteT) => ({ t0: desde * 24, t1: Math.min((hasta + 1) * 24, corteT) });
  const lyWin = (w, desdeLy) => ({ t0: desdeLy * 24, t1: desdeLy * 24 + Math.max(0, w.t1 - w.t0) });
  const z = () => ({ inv: 0, ses: 0, tk: 0, rev: 0 });

  function sumBy(rows, w, filter, key) {
    const out = new Map();
    for (const r of rows) {
      if (r.t < w.t0 || r.t >= w.t1) continue;
      if (filter && !filter(r)) continue;
      const k = key(r); let o = out.get(k); if (!o) { o = z(); out.set(k, o); }
      if (r.inv !== undefined) o.inv += r.inv;
      if (r.ses !== undefined) { o.ses += r.ses; o.tk += r.tk; o.rev += r.rev; }
    }
    return out;
  }
  const add = (...os) => os.reduce((a, o) => { if (o) { a.inv += o.inv; a.ses += o.ses; a.tk += o.tk; a.rev += o.rev; } return a; }, z());
  const div = (a, b) => (b ? a / b : null);

  function metrics(o, tc) {
    // inv viene normalizado a UYU (buildSrc ×NORM_TC) → /tc para mostrar en la moneda del toggle,
    // igual que la venta. roas/cvr son ratios de montos internos (UYU) → currency-neutral.
    const ing = o.rev / tc, invd = o.inv / tc;
    return { inv: invd, ses: o.ses, ing, tk: o.tk, cps: div(invd, o.ses), cpa: div(invd, o.tk), cvr: div(o.tk, o.ses), roas: div(o.rev, o.inv), aov: div(ing, o.tk) };
  }

  const KPI_COLS = [
    { label: 'Inversión', fmt: 'usd' }, { label: 'Sesiones', fmt: 'int' }, { label: 'Ingresos', fmt: 'usd' }, { label: 'Tickets', fmt: 'int' },
    { label: 'CPS', fmt: 'usd2' }, { label: 'CPA', fmt: 'usd2' }, { label: 'CVR', fmt: 'pct2' }, { label: 'ROAS', fmt: 'x' }, { label: 'AOV', fmt: 'usd' },
  ];
  const kpiCells = (m) => [m.inv, m.ses, m.ing, m.tk, m.cps, m.cpa, m.cvr, m.roas, m.aov];

  /* Pago: inversión de las plataformas + sesiones/tickets/ventas que Shopify atribuye a medios pagos */
  function paidBy(D, w, brandFilter, key) {
    const inv = sumBy(D.ads, w, brandFilter, key);
    const sh = sumBy(D.shop, w, (r) => r.paid && (!brandFilter || brandFilter(r)), key);
    const keys = new Set([...inv.keys(), ...sh.keys()]);
    const out = new Map();
    for (const k of keys) { const a = inv.get(k) || z(); const s = sh.get(k) || z(); out.set(k, { inv: a.inv, ses: s.ses, tk: s.tk, rev: s.rev }); }
    return out;
  }

  function tablaTipos(D, ctx, brand) {
    const f = brand ? (r) => r.m === brand : null;
    const g = paidBy(D, ctx.w, f, (r) => r.p + '|' + r.c);
    const rows = [];
    const plats = [['Google', GOOGLE_TYPES], ['Meta', META_TYPES]];
    const subs = [];
    for (const [p, types] of plats) {
      const extra = [...g.keys()].filter((k) => k.startsWith(p + '|') && !types.includes(k.slice(p.length + 1))).map((k) => k.slice(p.length + 1));
      const list = [...types, ...extra];
      const parts = list.map((t) => g.get(p + '|' + t) || z());
      list.forEach((t, i) => rows.push({ cells: [p, t, ...kpiCells(metrics(parts[i], ctx.tc))] }));
      const sub = add(...parts); subs.push(sub);
      rows.push({ cls: 'sub', cells: ['Total ' + p, '', ...kpiCells(metrics(sub, ctx.tc))] });
    }
    rows.push({ cls: 'total', cells: ['Total pago', '', ...kpiCells(metrics(add(...subs), ctx.tc))] });
    return { cols: [{ label: 'Plataforma', fmt: 'txt' }, { label: 'Tipo de campaña', fmt: 'txt' }, ...KPI_COLS], rows };
  }

  function tablaPlataformas(D, ctx, brand) {
    const f = brand ? (r) => r.m === brand : null;
    const g = paidBy(D, ctx.w, f, (r) => r.p);
    const parts = ['Google', 'Meta'].map((p) => g.get(p) || z());
    const rows = ['Google', 'Meta'].map((p, i) => ({ cells: [p, ...kpiCells(metrics(parts[i], ctx.tc))] }));
    rows.push({ cls: 'total', cells: ['Total', ...kpiCells(metrics(add(...parts), ctx.tc))] });
    return { cols: [{ label: 'Plataforma', fmt: 'txt' }, ...KPI_COLS], rows };
  }

  /* Diaria: base 'pago' (atribuido a medios pagos) o 'total' (todo el sitio) */
  function tablaDiaria(D, ctx, brand, base) {
    const f = brand ? (r) => r.m === brand : null;
    const inv = sumBy(D.ads, ctx.w, f, (r) => r.d);
    const sh = sumBy(D.shop, ctx.w, (r) => (base === 'total' || r.paid) && (!f || f(r)), (r) => r.d);
    const rows = []; const all = [];
    const d0 = Math.floor(ctx.w.t0 / 24); const d1 = Math.ceil(ctx.w.t1 / 24) - 1;
    for (let d = d0; d <= d1; d++) {
      const o = { inv: (inv.get(d) || z()).inv, ...(() => { const s = sh.get(d) || z(); return { ses: s.ses, tk: s.tk, rev: s.rev }; })() };
      all.push(o);
      const m = metrics(o, ctx.tc);
      rows.push({ cells: [dayStr(d), m.inv, m.ses, m.ing, m.tk, m.cpa, m.cvr, m.roas, m.cps] });
    }
    const m = metrics(add(...all), ctx.tc);
    rows.push({ cls: 'total', cells: ['Total', m.inv, m.ses, m.ing, m.tk, m.cpa, m.cvr, m.roas, m.cps] });
    return {
      cols: [{ label: 'Día', fmt: 'txt' }, { label: 'Inversión', fmt: 'usd' }, { label: 'Sesiones', fmt: 'int' }, { label: 'Ingresos', fmt: 'usd' }, { label: 'Tickets', fmt: 'int' },
        { label: 'CPA', fmt: 'usd2' }, { label: 'CVR', fmt: 'pct2' }, { label: 'ROAS', fmt: 'x' }, { label: 'CPS', fmt: 'usd2' }],
      rows,
    };
  }

  const vsLy = (a, b) => [a, b, div(a, b), a - b];

  /* Control por período (PRE / CYBER / EXTENDIMOS): a la fecha y hora del corte vs mismo tramo del año anterior */
  function tablaControl(D, ctx, periodo) {
    const P = D.periodos.find((x) => x.p === periodo);
    if (!P) return null;
    const w = win(P.a, P.b, ctx.corteT); const wl = lyWin(w, P.la);
    const inv = sumBy(D.ads, w, null, (r) => r.m); const invL = sumBy(D.ads, wl, null, (r) => r.m);
    const sh = sumBy(D.shop, w, null, (r) => r.m); const shL = sumBy(D.shop, wl, null, (r) => r.m);
    const objs = new Map();
    for (const o of D.obj) if (o.d >= P.a && o.d <= P.b) { const a = objs.get(o.m) || { inv: 0, venta: 0 }; a.inv += o.inv; a.venta += o.venta; objs.set(o.m, a); }
    const line = (label, i, iL, s, sL, ob, roiObj, cls) => ({
      cls,
      cells: [label, ob.inv, ob.venta, ob.venta / ctx.tc, roiObj,
        ...vsLy(i, iL), ...vsLy(s.rev / ctx.tc, sL.rev / ctx.tc), ...vsLy(s.ses, sL.ses),
        ...(() => { const c = div(s.tk, s.ses), cl = div(sL.tk, sL.ses); return [c, cl, c != null && cl ? c / cl : null, c != null && cl != null ? c - cl : null]; })()],
      colors: { 11: 'ly', 15: 'ly', 19: 'ly' },
    });
    const rows = []; const T = { i: 0, iL: 0, s: z(), sL: z(), ob: { inv: 0, venta: 0 }, roiW: 0 };
    for (const m of D.brands) {
      const i = (inv.get(m) || z()).inv, iL = (invL.get(m) || z()).inv, s = sh.get(m) || z(), sL = shL.get(m) || z();
      const ob = objs.get(m) || { inv: 0, venta: 0 }; const roiObj = D.roi.has(periodo + '|' + m) ? D.roi.get(periodo + '|' + m) : null;
      rows.push(line(m, i, iL, s, sL, ob, roiObj));
      T.i += i; T.iL += iL; T.s = add(T.s, s); T.sL = add(T.sL, sL); T.ob.inv += ob.inv; T.ob.venta += ob.venta; if (roiObj != null) T.roiW += roiObj * ob.inv;
    }
    rows.push(line('TOTAL', T.i, T.iL, T.s, T.sL, T.ob, div(T.roiW, T.ob.inv), 'total'));
    const y = periodoYears(P);
    const blk = (n, f) => [{ label: n + ' ' + y[0], fmt: f }, { label: n + ' ' + y[1], fmt: f }, { label: '% vs ' + y[1], fmt: 'pct' }, { label: 'Diferencia', fmt: f === 'pct2' ? 'pp' : f }];
    return {
      groups: [{ label: '', span: 1 }, { label: 'Objetivos', span: 4 }, { label: 'Inversión', span: 4 }, { label: 'Ingresos', span: 4 }, { label: 'Sesiones', span: 4 }, { label: 'CR', span: 4 }],
      cols: [{ label: 'Marca', fmt: 'txt' }, { label: 'Inversión', fmt: 'usd' }, { label: 'Objetivo venta UY', fmt: 'uyu' }, { label: 'Objetivo USD', fmt: 'usd' }, { label: 'ROI objetivo', fmt: 'x' },
        ...blk('Inv', 'usd'), ...blk('Ing', 'usd'), ...blk('Ses', 'int'), ...blk('CR', 'pct2')],
      rows,
      rango: [dayStr(P.a), dayStr(P.b), dayStr(P.la), dayStr(P.lb)],
      corteLy: w.t1 > w.t0 ? wl.t1 : null,
    };
  }
  const periodoYears = (P) => [dayStr(P.a).slice(0, 4), dayStr(P.la).slice(0, 4)];

  /* Proporción del día cubierta al corte, según la curva horaria de ventas del mismo día del año anterior */
  function shareDia(D, dia, hora) {
    if (hora >= 24) return 1;
    let tot = 0, cum = 0; const ld = dia - LY_OFFSET_DIAS;
    for (const r of D.shop) if (r.d === ld) { tot += r.rev; if (r.t - ld * 24 < hora) cum += r.rev; }
    return tot ? cum / tot : hora / 24;
  }

  /* Control de marcas: tráfico, conversión y venta (Shopify y GA4) vs objetivo y año anterior */
  function tablaMarcas(D, ctx) {
    const w = ctx.w; const wl = lyWin(w, ctx.desde - LY_OFFSET_DIAS);
    const sh = sumBy(D.shop, w, null, (r) => r.m); const shL = sumBy(D.shop, wl, null, (r) => r.m);
    const ga = sumBy(D.ga, w, null, (r) => r.m); const inv = sumBy(D.ads, w, null, (r) => r.m);
    const invL = sumBy(D.ads, wl, null, (r) => r.m); // inversión del año anterior (mismo tramo −364)
    // venta atribuida a medios pagos (Shopify último clic → Google/Meta), actual y año anterior
    const sp = sumBy(D.shop, w, (r) => r.paid, (r) => r.m); const spL = sumBy(D.shop, wl, (r) => r.paid, (r) => r.m);
    const corteDia = Math.floor(ctx.corteT / 24), corteHora = ctx.corteT - corteDia * 24;
    const sh24 = shareDia(D, corteDia, corteHora);
    const objs = new Map();
    const zo = () => ({ inv: 0, venta: 0, ses: 0, tk: 0 });
    for (const o of D.obj) {
      if (o.d < ctx.desde || o.d > ctx.hasta || o.d > corteDia) continue;
      const f = o.d === corteDia ? sh24 : 1;
      const a = objs.get(o.m) || zo();
      a.inv += o.inv * f; a.venta += o.venta * f; a.ses += o.ses * f; a.tk += o.tk * f; objs.set(o.m, a);
    }
    const line = (label, s, sL, g, i, iL, ob, p, pL, cls) => {
      const cr = div(s.tk, s.ses), crG = div(g.tk, g.ses), crO = div(ob.tk, ob.ses), crL = div(sL.tk, sL.ses);
      const v = s.rev / ctx.tc, vG = g.rev / ctx.tc, vO = ob.venta / ctx.tc, vL = sL.rev / ctx.tc;
      return {
        cls,
        cells: [label, s.ses, g.ses, ob.ses, div(s.ses, ob.ses), sL.ses, (sL.ses ? s.ses / sL.ses - 1 : null),
          cr, crG, crO, crL,
          v, vG, vO, div(v, vO), vL, (vL ? v / vL - 1 : null),
          i / ctx.tc, ob.inv / ctx.tc, div(i, ob.inv), div(i, s.rev),
          iL / ctx.tc, (iL ? i / iL - 1 : null), // 21=inversión AA, 22=% vs AA inversión (append: no corre los índices previos)
          // 23=venta paid, 24=% paid (venta paid ÷ venta), 25=venta paid AA, 26=% paid AA. Ratios de UYU interno → neutrales a la moneda.
          p.rev / ctx.tc, div(p.rev, s.rev), pL.rev / ctx.tc, div(pL.rev, sL.rev)],
        colors: { 4: 'obj', 6: 'growth', 7: { vs: 9 }, 14: 'obj', 16: 'growth', 22: 'growth' },
      };
    };
    const rows = []; const T = { s: z(), sL: z(), g: z(), i: 0, iL: 0, ob: zo(), p: z(), pL: z() };
    for (const m of D.brands) {
      const s = sh.get(m) || z(), sL = shL.get(m) || z(), g = ga.get(m) || z(), i = (inv.get(m) || z()).inv, iL = (invL.get(m) || z()).inv, ob = objs.get(m) || zo();
      const p = sp.get(m) || z(), pL = spL.get(m) || z();
      rows.push(line(m, s, sL, g, i, iL, ob, p, pL));
      T.s = add(T.s, s); T.sL = add(T.sL, sL); T.g = add(T.g, g); T.i += i; T.iL += iL; for (const k in T.ob) T.ob[k] += ob[k]; T.p = add(T.p, p); T.pL = add(T.pL, pL);
    }
    rows.push(line('TOTAL', T.s, T.sL, T.g, T.i, T.iL, T.ob, T.p, T.pL, 'total'));
    return {
      groups: [{ label: '', span: 1 }, { label: 'Tráfico', span: 6 }, { label: 'Conversión', span: 4 }, { label: 'Venta', span: 6 }, { label: 'Inversión', span: 6 }, { label: 'Venta paid', span: 4 }],
      cols: [{ label: 'Marca', fmt: 'txt' },
        { label: 'Sesiones Shopify', fmt: 'int' }, { label: 'Sesiones GA4', fmt: 'int' }, { label: 'Objetivo', fmt: 'int' }, { label: '% objetivo', fmt: 'pct' }, { label: 'Año anterior', fmt: 'int' }, { label: '% vs AA', fmt: 'pct' },
        { label: 'CR Shopify', fmt: 'pct2' }, { label: 'CR GA4', fmt: 'pct2' }, { label: 'CR objetivo', fmt: 'pct2' }, { label: 'CR año anterior', fmt: 'pct2' },
        { label: 'Venta Shopify', fmt: 'usd' }, { label: 'Venta GA4', fmt: 'usd' }, { label: 'Objetivo', fmt: 'usd' }, { label: '% objetivo', fmt: 'pct' }, { label: 'Año anterior', fmt: 'usd' }, { label: '% vs AA', fmt: 'pct' },
        { label: 'Inversión', fmt: 'usd' }, { label: 'Presupuesto', fmt: 'usd' }, { label: '% presupuesto', fmt: 'pct' }, { label: '% marketing', fmt: 'pct' }, { label: 'Inv. año anterior', fmt: 'usd' }, { label: '% vs AA', fmt: 'pct' },
        { label: 'Venta paid', fmt: 'usd' }, { label: '% paid', fmt: 'pct' }, { label: 'Venta paid AA', fmt: 'usd' }, { label: '% paid AA', fmt: 'pct' }],
      rows,
      ly: [dayStr(Math.floor(wl.t0 / 24)), wl.t1],
    };
  }

  function contexto(D, p) {
    const desde = dayIdx(p.desde), hasta = dayIdx(p.hasta);
    const corteT = dayIdx(p.corte_fecha) * 24 + Math.min(24, Math.max(0, num(p.corte_hora)));
    const tc = num(p.tc) > 0 ? num(p.tc) : 41;
    return { desde, hasta, corteT, tc, w: win(desde, hasta, corteT) };
  }

  /* Resumen para la línea del encabezado */
  function resumen(D, ctx) {
    const t = tablaMarcas(D, ctx).rows.at(-1).cells;
    const p = tablaPlataformas(D, ctx, null).rows.at(-1).cells;
    return { venta: t[11], ventaObj: t[14], ventaLy: t[16], inv: t[17], roasPago: p[8] };
  }

  root.FX = { prep, contexto, tablaTipos, tablaPlataformas, tablaDiaria, tablaControl, tablaMarcas, resumen, dayIdx, dayStr, clasificar, LY_OFFSET_DIAS };
})(typeof window !== 'undefined' ? window : globalThis);
